// Always include common JS to page-specific
import '/js/common/index';

import 'node-snackbar';

import {
    initCatalogFilters,
    initCatalogFiltersModal,
    initSelectedFilters,
    initSortAndPaging
} from '../../common/catalog-filters';
import { renderProductUnavailableButtons } from '../../common/functions';
import { initScrollableNavigations } from './functions';

if (window.isMobileBackend) {
    initSelectedFilters();
    initCatalogFiltersModal();
} else {
    initCatalogFilters();
    initScrollableNavigations();
}
initSortAndPaging();
renderProductUnavailableButtons();